<template>
  <VModal name="user-delete-modal" :loading="loading">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('users.deleteUser') }}</h2>
    </template>
    <template v-slot:content>
      <i18n path="users.removeUserWarning" tag="p">
        <template v-slot:name>
          <span><b>{{ user.name }}</b></span>
        </template>
      </i18n>
      <VMessage
        type="error"
        :fullwidth="true"
        v-if="user.id === $store.state.user.user.id">
        <template v-slot:icon>
          <ExclamationCircleIcon />
        </template>
        <template v-slot:text>
          {{ $t('users.deleteOwnAccountWarning') }}
        </template>
      </VMessage>
      <VForm :onSubmit="validateForm" data-vv-scope="user-delete">
        <div slot="formButtons" type="left">
          <VButton
            type="outline-1"
            :action="modalBack"
            data-test="button-cancel-delete-user"
            data-ec="users_delete_user_modal"
            data-et="cancel_button">
            <span>{{ $t('functional.cancel') }}</span>
          </VButton>
        </div>
        <div slot="formButtons" type="right">
          <VButton
            type="error"
            subtype="submit"
            data-test="button-confirm-delete-user"
            data-ec="users_delete_user_modal"
            data-et="delete_user_button">
            <TrashIcon />
            <span>{{ user.id === $store.state.user.user.id ? $t('users.deleteMe') : $t('users.deleteUser') }}</span>
          </VButton>
        </div>
      </VForm>
    </template>
  </VModal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import { TrashIcon, ExclamationCircleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'DeleteUserModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    user: {
      type: [Object],
      required: true,
    },
    storeAction: {
      type: [String],
      required: true,
    },
  },
  components: {
    VButton,
    VMessage,
    VForm,
    VModal,
    TrashIcon,
    ExclamationCircleIcon,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    modalBack() {
      this.$emit('cancel');
      this.$bus.$emit('closeModal');
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.loading = true;
          this.$store.dispatch(this.storeAction, this.user).then(() => {
            // TODO move this to the store or get rid
            if (this.user.id === this.$store.state.user.user.id) { // 'Logout' the user if they delete their own account successfully
              this.$store.dispatch('auth/LOGOUT');
            }
            this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('message.success.delete', { name: 'user' }), icon: 'check', type: 'success' }));
            this.$bus.$emit('closeModal');
            this.$emit('onUserDeleted', this.user.id);
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
